import clsx from 'clsx'

/**
 * Progress dots with an "N of M" label. Ported from the Tailwind Plus reference
 * design/components/navigation/progress-bars/03-bullets.jsx. Display only: moving between steps is
 * done with the wizard's Back and Next buttons.
 */
export function Steps({ current, total, className }: { current: number; total: number; className?: string }) {
  return (
    <nav aria-label="Progress" className={clsx('flex items-center', className)}>
      <p className="text-sm/6 font-medium text-zinc-950 dark:text-white">
        Step {current + 1} of {total}
      </p>
      <ol role="list" className="ml-6 flex items-center space-x-4">
        {Array.from({ length: total }, (_, i) => (
          <li key={i}>
            {i < current ? (
              <span className="block size-2.5 rounded-full bg-emerald-600 dark:bg-emerald-500">
                <span className="sr-only">Step {i + 1}, done</span>
              </span>
            ) : i === current ? (
              <span aria-current="step" className="relative flex items-center justify-center">
                <span aria-hidden="true" className="absolute flex size-5 p-px">
                  <span className="size-full rounded-full bg-emerald-200 dark:bg-emerald-900" />
                </span>
                <span aria-hidden="true" className="relative block size-2.5 rounded-full bg-emerald-600 dark:bg-emerald-500" />
                <span className="sr-only">Step {i + 1}, current</span>
              </span>
            ) : (
              <span className="block size-2.5 rounded-full bg-zinc-200 dark:bg-white/15">
                <span className="sr-only">Step {i + 1}</span>
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  )
}
